import { Form, Formik } from 'formik';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { ErrorMessageLabel } from '../../components/ErrorMessageLabel/ErrorMessageLabel';
import { InputField } from '../../components/InputField/InputField';
import { Project } from '../../../models/Project/Project';
import { Col, FormGroup, FormLabel } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import style from './create-project.module.scss';

function CreateProject() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <div className={style.formWrapper}>
      <h1 className="cs-title">Kreiraj Projekat</h1>
      <Formik
        initialValues={{
          name: '',
          price: 0,
          duration: 1,
          points_required: 0
        }}
        validationSchema={Yup.object({
          name: Yup.string().required('Ime je obavezno'),
          price: Yup.number()
            .required('Cena je obavezna')
            .min(0, 'Cena ne može biti negativna'),
          duration: Yup.number()
            .required('Trajanje je obavezno')
            .min(1, 'Trajanje mora biti barem 1'),
          points_required: Yup.number()
            .required('Poeni su obavezni')
            .min(0, 'Poeni ne mogu biti negativni')
        })}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          try {
            const project = await Project.store(values);
            resetForm();
            await queryClient.invalidateQueries(['projects']);
            toast.success(`Projekat "${project.name}" uspešno sačuvan!`);
            setTimeout(() => {
              navigate('/admin/projects/list');
            }, 800);
          } catch (error: any) {
            toast.error(
              error?.response?.data?.message || 'Greška pri snimanju projekta.'
            );
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off" className="cs-form-wrapper">
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Ime</FormLabel>
                <InputField name="name" placeholder="Unesite ime" type="text" />
                <ErrorMessageLabel name="name" />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Cena</FormLabel>
                <InputField
                  name="price"
                  placeholder="Unesite cenu"
                  type="number"
                  step="0.01"
                />
                <ErrorMessageLabel name="price" />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Trajanje</FormLabel>
                <InputField
                  name="duration"
                  placeholder="Unesite trajanje"
                  type="number"
                  step="1"
                />
                <ErrorMessageLabel name="duration" />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col lg={6}>
                <FormLabel>Poeni</FormLabel>
                <InputField
                  name="points_required"
                  placeholder="Unesite poene"
                  type="number"
                  step="1"
                />
                <ErrorMessageLabel name="points_required" />
              </Col>
            </FormGroup>
            <ButtonPrimary type="submit" disabled={isSubmitting}>
              Kreiraj
            </ButtonPrimary>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default CreateProject;
